module.exports = __webpack_public_path__ + "static/img/GrabRebateLogBg.291475a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SdkV3/GrabRebateLogBg.png
// module id = YFG1
// module chunks = 39